import actions from '../actions/actions';

const _initialState = {
    reportInProgress: false,
    reportSubmitted: false
};

export default function reportErrorReducer (state = _initialState, action) {
    switch (action.type) {
    case 'OPEN_REPORT_ERROR':
        return _initialState;

    case actions.REPORT_ERROR_IN_PROGRESS:
        return {...state, inProgress: true, submitted: false};

    case actions.REPORT_ERROR_SUCCESS:
        return {...state, inProgress: false, submitted: true};

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./app/reducers/reportError.js